import React, { useEffect } from 'react';
import { appendScript } from './Template';

function FAQ({ ...rest }) {

    useEffect(() => {
        appendScript("https://apps.elfsight.com/p/platform.js")
    })

    return (
    <div>
        <div className="sect-faq-imagen">
            <h1 className="h1-dimo padd-bottom">Preguntas Frecuentes Dimo</h1>
            <div className="container-example w-container">
            <div className="w-embed w-script">
                {/*<script src="https://apps.elfsight.com/p/platform.js" defer=""></script>*/}
                <div className="elfsight-app-f33391cd-b45d-4cc2-86c3-f41aa1da9819"></div>
            </div>
            </div>
        </div>
    </div>
    );
}

export default FAQ;